// extracted by mini-css-extract-plugin
export default {"quantity-column":"TeuJ_","quantityColumn":"TeuJ_","prices":"VtIJ_","total-price":"F5R4h","totalPrice":"F5R4h"};